import { getInfoTip } from '@/services/common';
import { isEqual } from '@/utils/util';
export default {
  name: 'HeaderNotice',
  i18n: require('./i18n-header'),
  data: function data() {
    return {
      loading: false,
      show: false,
      data: {}
    };
  },
  computed: {},
  mounted: function mounted() {
    this.getInfo();
  },
  methods: {
    fetchNotice: function fetchNotice() {
      var _this = this;
      if (this.loading) {
        this.loading = false;
        return;
      }
      this.loadding = true;
      setTimeout(function () {
        _this.loadding = false;
      }, 1000);
      this.getInfo();
    },
    getInfo: function getInfo() {
      var _this2 = this;
      getInfoTip().then(function (response) {
        if (response.data.code == 200) {
          _this2.data = response.data.data;
        }
      });
    }
  }
};